module.exports = __webpack_public_path__ + "img/facial-coding-img.a51f6550.svg";